

export default function DoubleClickers() {
    let clickers = [];

    for (const el of document.querySelectorAll('.dont-double-click-me')) {
        const click = new DoubleClicker(el);
        clickers.push(click);
    }

    return {
    };
}


function spinner(type, size) {
    const span = document.createElement('span');

    span.classList.add(`spinner-${type}`);
    if (size)
        span.classList.add(`spinner-${type}-${size}`);

    span.setAttribute('role', 'status');
    span.setAttribute('aria-hidden', 'true');

    return span;
}

const RESTORE_AFTER_SECONDS = 10;

function DoubleClicker(el, restoreDelay) {
    let clicked = false;

    function click(e) {
        if (clicked) {
            e.preventDefault();
            return;
        }

        clicked = true;

        let restore = function () { };
        function onRestore(fn) {
            const next = restore;
            restore = function () {
                fn();
                next();
            };
        }


        if (el.classList.contains('btn')) {
            const snurr = spinner('grow', 'sm');
            if (el.children.length)
                el.insertBefore(snurr, el.children[0]);
            else
                el.appendChild(snurr);
            onRestore(() => el.removeChild(snurr));

            if (el.type == 'BUTTON') {
                if (!el.hasAttribute('disabled')) {
                    el.setAttribute('disabled', 'disabled');
                    onRestore(() => el.removeAttribute('disabled'));
                }
            } else {
                if (!el.classList.contains('disabled')) {
                    el.classList.add('disabled');
                    onRestore(() => el.classList.remove('disabled'));
                }
            }
        }

        if (el.classList.contains('form-primary-cta')) {
            const snurr = spinner('grow', 'sm');
            el.appendChild(snurr);
            onRestore(() => el.removeChild(snurr));

            if (!el.classList.contains('disabled')) {
                el.classList.add('disabled');
                onRestore(() => el.classList.remove('disabled'));
            }
        }

        setTimeout(function () {
            if (restore)
                restore();
            clicked = false;
        }, restoreDelay || (RESTORE_AFTER_SECONDS * 1000));
    };

    if (el.form)
        el.form.addEventListener('submit', click);
    else
        el.addEventListener('click', click);

    return {};
}
